NtechApp.AboutUs = function($view) {
    var me = this;

    this._$view = null;

    this._$controls = null;
    this._$slider = null;

    this._$imagesSliderControls = null;
    this._$imageSlider = null;

    this._$statItems = null;

    this._touchClickEvent = null;
    this._slider = null;

    this._$graphInfo = null;
    //this._$leftParallaxOverlay = null;
    //this._$rightParallaxOverlay = null;
    this._$circles = null;

    this._$slideshowNextButton = null;
    this._$slideshowPrevButton = null;

    this._$slideshowGrid = null;
    this._$slidesNavGrid = null;

    this._slideshowGridTabsCount = null;
    this._currentSlideshowGridTab = 0;
    this._showNextSlideshowGridItemTimeout = null;
    this._isFirstSlideshowGridItemShow = true;

    this._slideshowGrid = null;
    this._slidesNavGrid = null;

    this._css = {
        ids: {
        },

        classes: {
            controls: "controls",
            controlsItem: "item",

            slides: "slides",
            slide: "slide",

            slideshowNextButton: "nextButtonWrapper",
            slideshowPrevButton: "prevButtonWrapper",

            slideshowButtonWrapper: "slideshowButtonWrapper",
            slideshowButton: "button",
            slideshowButtonActive: "active",
            slideshowButtonAfterActive: "afterActive",

            slideshowGrid: "slideshowGrid",
            slideshowGridItem: "gridItem",
            slideshowSlideContent: "slideContent",

            slidesNavGrid: "slidesNavGrid",
            slidesNavGridItem: "navItem"
        },

        data: {
            slideNum: "data-slide-num",
            slideshowGridItemFilterName: "data-grid-item-filter-name",
            slidesNavGridItemPos: "data-slides-nav-grid-item-pos"
        }
    }

    this._construct = function () {
        me._$view = $view;

        me._$controls = me._$view.find(".infoSlider").find("." + me._css.classes.controls);
        me._$slider = me._$view.find(".infoSlider").find("." + me._css.classes.slides);

        me._$imagesSliderControls = me._$view.find(".imagesSlider").find("." + me._css.classes.controls);
        me._$imagesSlider = me._$view.find(".imagesSlider").find("." + me._css.classes.slides);

        me._$statItems = me._$view.find(".info .stat");

        me._touchClickEvent = new NtechApp.TouchClickEvent();
        me._slider = new NtechApp.Slider(me._$slider, me._css.classes.slide);
        me._imagesSlider = new NtechApp.Slider(me._$imagesSlider, me._css.classes.slide);

        me._$graphInfo = me._$view.find(".graphInfo");
        //me._$leftParallaxOverlay = $("<div class='graphInfoParallaxOverlay'></div>").appendTo("body");
        //me._$rightParallaxOverlay = $("<div class='graphInfoParallaxOverlay'></div>").appendTo("body");
        me._$circles = me._$view.find(".graphInfo .circle");

        //me._animateStatItems();

        me._$slideshowNextButton = me._$view.find("." + me._css.classes.slideshowNextButton);
        me._$slideshowPrevButton = me._$view.find("." + me._css.classes.slideshowPrevButton);

        me._$slideshowGrid = me._$imagesSlider;
        me._$slidesNavGrid = me._$view.find("." + me._css.classes.slidesNavGrid);

        me._slideshowGridTabsCount = me._$slidesNavGrid.find("." + me._css.classes.slidesNavGridItem).length;

        setTimeout(function() {
            me._createCircles();
            me._scheduleNextSlideshowGridItemShow();
        }, 200);

        me._createParallaxScroller();
        //me._createParallaxOverlays();
        //me._updateParallaxOverlays();

        // Parallax show fix
        setTimeout(function() {
            $(window).trigger("scroll");
            $(document).trigger(NtechApp.AboutUs.EVENT_DOCUMENT_SCROLL);
        }, 200);

        me._bindEvents();
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.AboutUs.EVENT_DOCUMENT_RESIZE, function() {
            //me._animateStatItems();
            //me._updateParallaxOverlays();
            me._createCircles();

            setTimeout(function() {
                $(window).trigger("scroll");
                $(document).trigger(NtechApp.AboutUs.EVENT_DOCUMENT_SCROLL);
            }, 200);
        });

        $(document).on(NtechApp.AboutUs.EVENT_DOCUMENT_SCROLL, function() {
            //me._animateStatItems();
            //me._updateParallaxOverlays();
            me._createCircles();
        });

        me._touchClickEvent.listen(me._$controls, "." + me._css.classes.controlsItem, function(event) {
            me._selectControlItem($(event.target));
            me._slider.slideTo($(event.target).attr(me._css.data.slideNum));

            setTimeout(function() {
                $(window).trigger("scroll");
                $(document).trigger(NtechApp.AboutUs.EVENT_DOCUMENT_SCROLL);
                $(window).trigger(NtechApp.AboutUs.EVENT_SLIDER_SLIDE_CHANGE);
            }, 500);
        });

        //me._touchClickEvent.listen(me._$imagesSliderControls, "." + me._css.classes.controlsItem, function(event) {
        //    me._selectImagesSliderControlItem($(event.target));
        //    me._imagesSlider.slideTo($(event.target).attr(me._css.data.slideNum));
        //});

        me._touchClickEvent.listen(me._$slidesNavGrid, "." + me._css.classes.slidesNavGridItem, function(event) {
            me._selectSlidesNavTab($(event.target));
        });

        me._touchClickEvent.listen(me._$slideshowNextButton, function() {
            me._unscheduleNextSlideshowGridItemShow();
            me._showNextSlideshowTab();
        });

        me._touchClickEvent.listen(me._$slideshowPrevButton, function() {
            me._unscheduleNextSlideshowGridItemShow();
            me._showPrevSlideshowTab();
        });

        me._$imagesSlider.on("mouseleave.NtechApp.AboutUs", function() {
            var $buttons = me._$view.find("." + me._css.classes.slideshowButtonWrapper).find("." + me._css.classes.slideshowButton);
            //$buttons.removeClass(me._css.classes.slideshowButtonActive).removeClass(me._css.classes.slideshowButtonAfterActive);
            $buttons.removeClass(me._css.classes.slideshowButtonActive);
        });

        me._$view.on("mouseenter.NtechApp.AboutUs", "." + me._css.classes.slideshowButtonWrapper, function() {
            var $buttons = me._$view.find("." + me._css.classes.slideshowButtonWrapper).find("." + me._css.classes.slideshowButton);
            $buttons.removeClass(me._css.classes.slideshowButtonAfterActive).addClass(me._css.classes.slideshowButtonActive);
        });

        me._$view.on("mouseleave.NtechApp.AboutUs", "." + me._css.classes.slideshowButtonWrapper, function() {
            var $buttons = me._$view.find("." + me._css.classes.slideshowButtonWrapper).find("." + me._css.classes.slideshowButton);
            $buttons.removeClass(me._css.classes.slideshowButtonActive).addClass(me._css.classes.slideshowButtonAfterActive);
        });
    }

    this._unbindEvents = function () {
        $(window).off(NtechApp.AboutUs.EVENT_DOCUMENT_RESIZE);
        $(document).off(NtechApp.AboutUs.EVENT_DOCUMENT_SCROLL);
        me._touchClickEvent.unlisten(me._$controls);
        me._slider.destruct();
        //me._touchClickEvent.unlisten(me._$imagesSliderControls);
        me._imagesSlider.destruct();
        $(".graphInfo > .image").imageScroll("destruct");
        $("#pageMainHeading > .desktopHeading").imageScroll("destruct");
        me._touchClickEvent.unlisten(me._$slidesNavGrid);
        me._touchClickEvent.unlisten(me._$slideshowNextButton);
        me._touchClickEvent.unlisten(me._$slideshowPrevButton);
        me._$view.off("mouseleave.NtechApp.AboutUs");
        me._$view.off("mouseenter.NtechApp.AboutUs");
        me._$imagesSlider.off("mouseleave.NtechApp.AboutUs");
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.AboutUs.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.AboutUs";
NtechApp.AboutUs.EVENT_DOCUMENT_RESIZE = "resize.NtechApp.AboutUs";
NtechApp.AboutUs.EVENT_SLIDER_SLIDE_CHANGE = "sliderSlideChange.NtechApp.AboutUs";

NtechApp.AboutUs.prototype._selectControlItem = function($control) {
    $.each(this._$controls.find("." + this._css.classes.controlsItem), function() {
        $(this).removeClass("active");
    });

    $control.addClass("active");
};

NtechApp.AboutUs.prototype._selectImagesSliderControlItem = function($control) {
    $.each(this._$imagesSliderControls.find("." + this._css.classes.controlsItem), function() {
        $(this).removeClass("active");
    });

    $control.addClass("active");
};

NtechApp.AboutUs.prototype._isItemInsideViewport = function($item) {
    var viewportScrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    var viewportScrollTop = window.pageYOffset || document.documentElement.offsetTop;

    var viewportCoords = {
        x1: viewportScrollLeft,
        x2: viewportScrollLeft + document.documentElement.clientWidth - 1,
        y1: viewportScrollTop,
        y2: viewportScrollTop + document.documentElement.clientHeight - 1
    };

    return ($item.offset().top >= viewportCoords.y1 &&
            $item.offset().top + $item.outerHeight() - 1 <= viewportCoords.y2);
};

NtechApp.AboutUs.prototype._animateStatItems = function() {
    var me = this;
    $.each(this._$statItems, function() {
        if($(this).hasClass("shown"))
            return;

        if(!me._isItemInsideViewport($(this)))
            return;

        $(this).addClass("shown");
        me._animateStatItem($(this));
    });
};

NtechApp.AboutUs.prototype._animateStatItem = function($item) {
    var animateTo = parseInt($item.attr("data-animate-to"));

    var $number = $item.find(".right");
    var $overlay = $item.find(".barOverlay");

    var iterations = 15;
    var animationStep = Math.floor(animateTo / iterations);
    var currentStep = 0;
    var nextTimeout = 0;

    var renderAnimationStep = function(currentStep) {
        currentStep = Math.floor(currentStep);
        $number.text(currentStep + "%");
        $overlay.css("width", currentStep + "%");
    }

    var lastCheck = function() {
        var itemText = parseInt($number.text().replace(/%/, ""), 10);
        if(itemText != animateTo) {
            setTimeout(function() { renderAnimationStep(animateTo); }, 0);
        }
    }

    var lastCheckTimeout = null;

    while(currentStep <= animateTo) {
        (function(nextTimeout, currentStep) {
            setTimeout(function() {
                if(lastCheckTimeout != null) {
                    clearTimeout(lastCheckTimeout);
                    lastCheckTimeout = null;
                }
                renderAnimationStep(currentStep);
                lastCheckTimeout = setTimeout(lastCheck, 100);
            },
            nextTimeout);
        })(nextTimeout, currentStep);

        currentStep += animationStep;
        nextTimeout += 100;
    }
};

NtechApp.AboutUs.prototype._createParallaxScroller = function() {
    $(".graphInfo > .image").imageScroll({
        holderMaxHeight: 500,
        container: $(".graphInfo")
    });

    $("#pageMainHeading > .desktopHeading").imageScroll({
        holderMaxHeight: 220,
        container: $("#pageMainHeading")
    });
};

//NtechApp.AboutUs.prototype._createParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        position: "absolute",
//        left: "0px",
//        top: this._$graphInfo.offset().top + "px",
//        width: "3%",
//        height: this._$graphInfo.height() + "px",
//        background: "white",
//        zIndex: "100"
//    });
//
//    this._$rightParallaxOverlay.css({
//        position: "absolute",
//        right: "0px",
//        top: this._$graphInfo.offset().top + "px",
//        width: "3%",
//        height: this._$graphInfo.height() + "px",
//        background: "white",
//        zIndex: "100"
//    });
//};
//
//NtechApp.AboutUs.prototype._updateParallaxOverlays = function() {
//    this._$leftParallaxOverlay.css({
//        top: this._$graphInfo.offset().top + "px",
//        height: this._$graphInfo.height() + "px"
//    });
//    this._$rightParallaxOverlay.css({
//        top: this._$graphInfo.offset().top + "px",
//        height: this._$graphInfo.height() + "px"
//    });
//};

NtechApp.AboutUs.prototype._createCircles = function() {
    var me = this;
    $.each(this._$circles, function() {
        if($(this).hasClass("shown"))
            return;

        if(!me._isItemInsideViewport($(this)))
            return;

        $(this).addClass("shown");
        (function($item) {
            setTimeout(function() { me._createCircle($item); }, 200);
        })($(this));
    });
};

NtechApp.AboutUs.prototype._createCircle = function($item) {
    var myCircle = Circles.create({
        id:                  $item.attr("id"),
        radius:              80,
        value:               parseInt($item.attr("data-animate-to"), 10),
        maxValue:            100,
        width:               8,
        text:                function(value){return value + '%';},
        colors:              ['#D3B6C6', '#4B253A'],
        duration:            1200,
        wrpClass:            'circles-wrp',
        textClass:           'circles-text',
        valueStrokeClass:    'circles-valueStroke',
        maxValueStrokeClass: 'circles-maxValueStroke',
        styleWrapper:        true,
        styleText:           true
    });
};

NtechApp.AboutUs.prototype._selectSlidesNavTab = function($slideTab) {
    var tabPos = parseInt($slideTab.attr(this._css.data.slidesNavGridItemPos), 10);
    //var linkedFilterName = this._slideshowGridFilterNames[tabPos - 1];

    this._unscheduleNextSlideshowGridItemShow();
    this._showSlideshowTab(tabPos - 1);
};

NtechApp.AboutUs.prototype._highlightSlidesNavTab = function(tabPos) {
    var me = this;
    var $slideTab = null;

    $.each(this._$slidesNavGrid.find("." + this._css.classes.slidesNavGridItem), function() {
        $(this).removeClass("active");
        if(parseInt($(this).attr(me._css.data.slidesNavGridItemPos), 10) == tabPos)
            $slideTab = $(this);
    });

    $slideTab.addClass("active");
};

NtechApp.AboutUs.prototype._unscheduleNextSlideshowGridItemShow = function() {
    if(this._showNextSlideshowGridItemTimeout != null) {
        clearTimeout(this._showNextSlideshowGridItemTimeout);
        this._showNextSlideshowGridItemTimeout = null;
    }
};

NtechApp.AboutUs.prototype._scheduleNextSlideshowGridItemShow = function() {
    var me = this;
    this._showNextSlideshowGridItemTimeout = setTimeout(function() {
        me._showNextSlideshowTab.call(me);
    }, 4000);
};

NtechApp.AboutUs.prototype._showNextSlideshowTab = function() {
    //this._currentSlideshowGridFilter++;
    //if(this._currentSlideshowGridFilter >= this._slideshowGridFilterNames.length)
    //    this._currentSlideshowGridFilter = 0;
    this._currentSlideshowGridTab++;
    if(this._currentSlideshowGridTab >= this._slideshowGridTabsCount)
        this._currentSlideshowGridTab = 0;

    this._showSlideshowTab(this._currentSlideshowGridTab);
};

NtechApp.AboutUs.prototype._showPrevSlideshowTab = function() {
    //this._currentSlideshowGridFilter--;
    //if(this._currentSlideshowGridFilter < 0)
    //    this._currentSlideshowGridFilter = this._slideshowGridFilterNames.length - 1;
    this._currentSlideshowGridTab--;
    if(this._currentSlideshowGridTab < 0)
        this._currentSlideshowGridTab = this._slideshowGridTabsCount - 1;

    this._showSlideshowTab(this._currentSlideshowGridTab);
};

NtechApp.AboutUs.prototype._showSlideshowTab = function(tabIndex) {
    this._currentSlideshowGridTab = tabIndex;
    this._highlightSlidesNavTab(tabIndex + 1);
    this._imagesSlider.slideTo(tabIndex);
    //this._slideshowGrid.setFilter(this._slideshowGridFilterNames[tabIndex]);
    this._scheduleNextSlideshowGridItemShow();
};